import { mediaQueries } from "../config"
import { useMediaQuery } from "../hooks"
import React, { createContext, useContext } from "react"

export const ScreensContext = createContext("screens")

/**
 * Screen size context provider
 *
 * Provides boolean matching for the named "screens" in Tailwind configuration.
 */
export function Screens({ children }) {
  const screens = {}
  Object.keys(mediaQueries).forEach(key => {
    // We can disable this because the media query hook isn’t really stateful
    // and so order doesn’t matter
    // eslint-disable-next-line react-hooks/rules-of-hooks
    screens[key] = useMediaQuery(mediaQueries[key])
  })
  return (
    <ScreensContext.Provider value={screens}>
      {children}
    </ScreensContext.Provider>
  )
}

function ComponentWithScreens({ component, componentProps }) {
  const Component = component
  const screens = useContext(ScreensContext)
  return <Component {...componentProps} screens={screens} />
}

export function withScreens(Component) {
  return componentProps => (
    <Screens>
      <ComponentWithScreens
        component={Component}
        componentProps={componentProps}
      />
    </Screens>
  )
}
